<template>
    <b-modal size="lg" id="send-mail-all" @ok="sendSmsAll" @show="onModalShow" @hidden="onModalHidden">

        <template #modal-title>
            <h6 class="fw-bold mb-0 akkurate-green">Send All Sms</h6>
        </template>

        <div v-if="formErrorSummary" class="alert alert-danger py-2 small mb-3">{{ formErrorSummary }}</div>
        <div v-if="isSingleCustomerMode" class="alert alert-info py-2 small mb-3">
            Single customer SMS uses <strong>customer_id</strong>; the message is sent to the mobile on file (not the field below).
            <span v-if="customerPhoneHint" class="d-block mt-1 text-muted">On-file hint: {{ customerPhoneHint }}</span>
        </div>
        <b-form-group v-if="!isSingleCustomerMode" label-for="recipient" class="mb-2" description="Number should be seperated by commas">
            <template #label>
                <div class="d-flex">
                    <b-form-radio-group v-model="selected" :options="options" @change="onRadioChange" aria-describedby="Bulk Sms" name="radio-inline"></b-form-radio-group>
                    <label class="akkurate-dark" for="recipient">Recipient <star></star></label>
                </div>
                <small class="text-danger d-block" v-if="fieldError('type')">{{ fieldError('type') }}</small>
                <small class="text-danger d-block" v-if="fieldError('selected')">{{ fieldError('selected') }}</small>
            </template>
            <!-- Account -->
             <div class="col-md-12 mb-2" v-if="selected === 'customer_type'">
                <label class="akkurate-dark small" for="priority">Customer Account type<star></star></label>
                <b-form-group id="priority" label-for="priority">
                    <multiselect class="mt-1 field-container" v-model="selectedAccountType" :options="customerAccountTypes" label="name" track-by="value">
                    </multiselect>
                    <small class="text-danger d-block" v-if="fieldError('selected.selected_customer_type') || fieldError('selected.selected_customer_type.value')">{{ fieldError('selected.selected_customer_type') || fieldError('selected.selected_customer_type.value') }}</small>
                    <!-- <errors v-if="errors.account_type">
                        {{ errors.account_type[0] }}
                    </errors> -->
                </b-form-group>
            </div>

            <!-- Account -->
             <div class="col-md-12 mb-2" v-if="selected === 'product'">
                <label class="akkurate-dark small" for="priority">Product type<star></star></label>
                <b-form-group id="priority" label-for="priority">
                    <multiselect class="mt-1 field-container" v-model="account_type" :options="account_types" label="name" track-by="id">
                    </multiselect>
                    <small class="text-danger d-block" v-if="fieldError('selected.selected_product') || fieldError('selected.selected_product.id')">{{ fieldError('selected.selected_product') || fieldError('selected.selected_product.id') }}</small>
                    <!-- <errors v-if="errors.account_type">
                        {{ errors.account_type[0] }}
                    </errors> -->
                </b-form-group>
            </div>

            <!-- Branch -->
            <div class="col-md-12 mb-2" v-if="selected === 'branch'">
                <label class="akkurate-dark small" for="priority">Branch<star></star></label>
                <b-form-group id="priority" label-for="priority">
                    <multiselect class="mt-1 field-container" v-model="branch" :options="branch_options" label="name" track-by="id">
                    </multiselect>
                    <small class="text-danger d-block" v-if="fieldError('selected.selected_branch') || fieldError('selected.selected_branch.id')">{{ fieldError('selected.selected_branch') || fieldError('selected.selected_branch.id') }}</small>
                    <!-- <errors v-if="errors.account_type">
                        {{ errors.account_type[0] }}
                    </errors> -->
                </b-form-group>
            </div>

            <b-form-textarea v-if="selected == 'custom'|| selected == 'bulk'" class="mt-2 fields" id="recipient" :key="recipientKey" v-model="recipient" rows="3" max-rows="10" :disabled="disable_recipient" placeholder="One phone (9–25 chars) or comma-separated list. Digits, +, spaces, hyphens only." @blur="onRecipientBlur"></b-form-textarea>
            <small class="text-danger d-block" v-if="recipientFieldError">{{ recipientFieldError }}</small>
            <!-- <errors v-if="form.errors.message">
									{{ form.errors.message[0] }}
								</errors> -->
        </b-form-group>
        <b-form-group label-for="message" class="mb-2">
            <template #label>
                <label class="akkurate-dark" for="message">Message <star></star></label>
            </template>
            <b-form-textarea class="mt-2 fields" id="message" v-model="sms_message" rows="6" max-rows="10" placeholder="Enter Message..." :maxlength="messageMaxLength"></b-form-textarea>
            <small class="text-muted d-block">Max {{ messageMaxLength }} characters{{ isFilteredAudience ? ' (multi-segment SMS allowed)' : '' }}.</small>
            <small class="text-danger d-block" v-if="fieldError('message')">{{ fieldError('message') }}</small>
            <small class="text-danger d-block" v-if="fieldError('customer_id')">{{ fieldError('customer_id') }}</small>
            <div class="row text-muted small">
                <div class="col-4">
                    {{ messageCharCount }} / {{ messageMaxLength }} character{{ messageCharCount !== 1 ? 's' : '' }}
                </div>
                <div class="col-4">
                    {{ messageSegments }} SMS segment{{ messageSegments !== 1 ? 's' : '' }} (160 chars each)
                </div>
            </div>
            <div class="row text-muted small" v-if="(selected == 'custom' || selected == 'bulk') && !isSingleCustomerMode">
                <div class="col-4">
                    {{ recipientCount }} recipient{{ recipientCount !== 1 ? 's' : '' }} entered
                </div>
                <div class="col-4" v-if="selected == 'custom'">
                    {{ messageSegments * recipientCount }} total segments (approx.)
                </div>
            </div>
        </b-form-group>

        <template #modal-footer="{ ok }">

            <div class="w-100">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button @click="$bvModal.hide('send-mail-all')" type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel
                    </span></b-button>
                <b-button @click="ok()" type="submit" :disabled="isSearching || isBusy" class="akkurate-green-btn btn-size float-right border-0"><span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'mail-forward']" />Forward</span></b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
// import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";

import ApiService from "@/core/services/api.service";
import {
	isValidSmsPhoneSegment,
	splitRecipientSegments,
	messageHasNonWhitespace,
	normalizeCommaRecipientsString,
	SMS_MESSAGE_SHORT_MAX,
	SMS_MESSAGE_FILTERED_MAX,
	SMS_MAX_COMMA_RECIPIENTS,
	SMS_CUSTOMER_TYPE_VALUES,
	SMS_PHONE_SEGMENT_MIN,
	SMS_PHONE_SEGMENT_MAX,
	sanitizeSmsRecipientsInput,
} from "@/utils/smsValidation.js";
import { apiErrorMessage } from "@/utils/apiErrorMessage.js";
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";


import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
// import MemberFilter from "../forms/MemberFilter.vue";
import MemberView from '@/views/main/pages/member/view/MemberView.vue'
import 'vue-good-table/dist/vue-good-table.css';
import Multiselect from 'vue-multiselect'
// import $ from 'jquery';
// import 'datatables.net';
// import config from '@/config.js'
// import JwtService from "@/core/services/jwt.service";

export default {
    components: {
        SidebarView,
        TopbarView,
        Footer,
        MemberView,
        Multiselect
    },
    props: {
        mobile_number: {
            type: String,
            default: "",
        },
        /** When set (e.g. from member list), POST /sms/request/customer — do not send phone as `phone`. */
        customerId: {
            type: [Number, String],
            default: null,
        },
        customerPhoneHint: {
            type: String,
            default: "",
        },
    },
    computed: {
        messageCharCount() {
            return this.sms_message ? this.sms_message.length : 0;
        },
        /** 160 for all-customers & comma phones; 612 for audience filters */
        messageMaxLength() {
            if (this.isSingleCustomerMode) {
                return SMS_MESSAGE_SHORT_MAX;
            }
            if (this.selected === "bulk" || this.selected === "custom") {
                return SMS_MESSAGE_SHORT_MAX;
            }
            return SMS_MESSAGE_FILTERED_MAX;
        },
        isSingleCustomerMode() {
            const id = this.customerId;
            if (id === null || id === undefined || id === "") {
                return false;
            }
            const n = Number(id);
            return Number.isFinite(n) && n > 0;
        },
        isFilteredAudience() {
            return ["branch", "product", "customer_type"].includes(this.selected);
        },
        messageSegments() {
            return Math.ceil(this.messageCharCount / 160) || 1;
        },
        recipientCount() {
            if (!this.recipient) return 0;
            return this.recipient
                .split(",")
                .map((num) => num.trim())
                .filter((num) => num.length > 0).length;
        },
        formErrorSummary() {
            return this.flattenErrors(this.formErrors);
        },
        /** Recipients / phone API field errors (including `recipients.*`). */
        recipientFieldError() {
            return (
                this.fieldError("recipients") ||
                this.fieldError("phone") ||
                this.fieldErrorPrefix("recipients.") ||
                null
            );
        },
    },
    data() {
        return {
            isSearching: false,
            isLoading: false,
            recipientKey: 0, // Key to force re-render of recipient input
            status_option: ['Pending', 'Active', 'Inactive', "Dormant", "Closed"],
            trans_source_options: [
                { name: 'USSD', value: "ussd" },
                { name: 'OFFICE', value: "office" },
                { name: 'MOBILE', value: "mobile" },
                // { name: 'Deposit', value: "deposit" },
                // { name: 'Withdrawal', value: "withdrawal" },
            ],
            selected: 'custom',
            options: [
                { text: 'Custom', value: 'custom' },
                { text: 'Bulk', value: 'bulk' },
                { text: 'Customer Account Type', value: 'customer_type' },
                { text: 'Product', value: 'product' },
                { text: 'Branch', value: 'branch' }
            ],
            selectedAccountType: null,
            customerAccountTypes: [
                { name: 'Individual', value: 'INDIVIDUAL' },
                { name: 'Group', value: 'GROUP' },
                { name: 'Corporate', value: 'CORPORATE' },
                { name: 'In trust', value: 'IN_TRUST' },
            ],
            recipient: "",
            message: "",
            sms_message: "",
            users_options: [],
            member_id: "",
            institution: {},
            totalRecords: 0,
            searchFilter: "",
            isBusy: false,
            account_types: [],
            account_type: '',
            branch_options: [],
            branch: null,
            region_options: [],
            currentPage: 1,
            perPage: 10,
            per_page_options: ['10', '20', '50', '100', '500', '1000', '5000', '10000'],
            per_page_selected: "10",
            disable_recipient: false,
            form: {
                status: "",
                search_term: "",
                from_date: "",
                to_date: "",
                trans_source: "",
                branch: "",
                start_date: "",
                end_date: "",
                gender: "",
                gender_option: ['Male', 'Female', 'Group'],
                users: []
            },

            fields: [
                {
                    label: '#',
                    key: 'id',
                },
                {
                    label: 'Type',
                    key: 'type',
                },
                {
                    label: 'Status',
                    key: 'status',
                },
                {
                    label: 'Requested By',
                    key: 'requested_by',
                },
                {
                    label: 'Actions',
                    key: 'actions',
                },
            ],
            rows: [],
            formErrors: {},
        };
    },
    mounted() {
        let token = localStorage.getItem('token');
        if (!token) {
            this.$router.push({ path: '/login' });
        }
        // this.getAccountDropdown();
        // this.loadItems();
        this.getInsistution();

        this.loadPageOptions();

    },
    methods: {
        flattenErrors(errors) {
            if (!errors || typeof errors !== "object") {
                return "";
            }
            const parts = [];
            Object.keys(errors).forEach((k) => {
                const v = errors[k];
                if (Array.isArray(v)) {
                    v.forEach((m) => {
                        if (typeof m === "string") {
                            parts.push(m);
                        }
                    });
                } else if (typeof v === "string") {
                    parts.push(v);
                } else if (v && typeof v === "object") {
                    Object.values(v).forEach((m) => {
                        if (typeof m === "string") {
                            parts.push(m);
                        } else if (Array.isArray(m) && m[0]) {
                            parts.push(String(m[0]));
                        }
                    });
                }
            });
            return parts.join(" ");
        },
        fieldError(key) {
            const e = this.formErrors[key];
            if (Array.isArray(e) && e.length) {
                return e[0];
            }
            if (typeof e === "string" && e) {
                return e;
            }
            return null;
        },
        /** First error for keys starting with prefix (e.g. recipients.0). */
        fieldErrorPrefix(prefix) {
            const errs = this.formErrors;
            if (!errs || typeof errs !== "object") {
                return null;
            }
            const keys = Object.keys(errs);
            for (let i = 0; i < keys.length; i++) {
                const k = keys[i];
                if (k === prefix || k.startsWith(prefix)) {
                    const e = errs[k];
                    if (Array.isArray(e) && e.length) {
                        return e[0];
                    }
                    if (typeof e === "string" && e) {
                        return e;
                    }
                }
            }
            return null;
        },
        clearFormErrors() {
            this.formErrors = {};
        },
        applyApiValidation(error) {
            const d = error.response && error.response.data;
            if (
                d &&
                d.errors &&
                typeof d.errors === "object" &&
                !Array.isArray(d.errors)
            ) {
                this.formErrors = { ...d.errors };
            } else {
                this.clearFormErrors();
            }
        },
        buildAudienceSelectedPayload() {
            const t = this.selected;
            if (t === "branch") {
                if (!this.branch || this.branch.id == null) {
                    return null;
                }
                const bid = Number(this.branch.id);
                if (!Number.isFinite(bid) || bid < 1) {
                    return null;
                }
                return {
                    selected_branch: {
                        id: bid,
                        name: this.branch.name || "",
                    },
                };
            }
            if (t === "product") {
                if (!this.account_type || this.account_type.id == null) {
                    return null;
                }
                const pid = Number(this.account_type.id);
                if (!Number.isFinite(pid) || pid < 1) {
                    return null;
                }
                return {
                    selected_product: {
                        id: pid,
                        name: this.account_type.name || "",
                    },
                };
            }
            if (t === "customer_type") {
                if (!this.selectedAccountType) {
                    return null;
                }
                const val =
                    typeof this.selectedAccountType === "object"
                        ? this.selectedAccountType.value
                        : this.selectedAccountType;
                if (val === null || val === undefined || String(val).trim() === "") {
                    return null;
                }
                const upper = String(val).trim().toUpperCase();
                if (!SMS_CUSTOMER_TYPE_VALUES.includes(upper)) {
                    return null;
                }
                return {
                    selected_customer_type: { value: upper },
                };
            }
            return null;
        },
        smsErrorSwal(icon, text, title) {
            const safeText = text != null ? String(text) : "";
            swal.fire({
                title: title != null ? String(title) : "",
                text: safeText,
                icon,
                allowOutsideClick: true,
                allowEscapeKey: true,
                showCancelButton: false,
                confirmButtonText: "OK",
                buttonsStyling: false,
                customClass: {
                    confirmButton:
                        "btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
                },
            });
        },
        handleSmsCatch(error) {
            this.$Progress.fail();
            this.isBusy = false;
            const status = error.response && error.response.status;
            const d = error.response && error.response.data;
            if (
                status === 422 &&
                d &&
                d.errors &&
                typeof d.errors === "object" &&
                !Array.isArray(d.errors)
            ) {
                this.applyApiValidation(error);
                const summary =
                    this.flattenErrors(d.errors) ||
                    (typeof d.message === "string" ? d.message : "") ||
                    "Please fix the highlighted fields.";
                this.smsErrorSwal("error", summary);
                return;
            }
            this.smsErrorSwal("error", apiErrorMessage(error, "Request failed."));
        },
        onModalShow() {
            this.clearFormErrors();
            this.initializeRecipient();
        },
        onModalHidden() {
            this.clearFormErrors();
            this.$emit("modal-hidden");
        },
        resetFields() {
            this.selected = "custom";
            this.selectedAccountType = null;
            this.account_type = null;
            this.branch = null;
            this.sms_message = "";
            this.recipient = "";
            this.clearFormErrors();
        },
        loadPageOptions() {
			this.$Progress.start();
			this.isLoading = true;
			ApiService.get("/customers/dropdown")
				.then((response) => {
					const data = response && response.data;
					this.account_types = (data && data.account_types) || [];
					this.region_options = (data && data.regions) || [];
					this.branch_options = (data && data.branches) || [];
					this.isLoading = false;
					this.$Progress.finish();
				})
				.catch(() => {
					this.isLoading = false;
					this.$Progress.fail();
				});
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        initializeRecipient() {
            if (this.isSingleCustomerMode) {
                this.recipient = "";
                return;
            }
            if (this.mobile_number) {
                this.recipient = sanitizeSmsRecipientsInput(this.mobile_number);
            }
        },
        onRecipientBlur() {
            if (this.isSingleCustomerMode || this.disable_recipient) {
                return;
            }
            const next = sanitizeSmsRecipientsInput(this.recipient);
            if (next !== this.recipient) {
                this.recipient = next;
            }
        },
        onRadioChange(value) {
            this.clearFormErrors();
            if (value == "bulk") {
                this.disable_recipient = true;
                this.recipient = "";
            } else {
                this.disable_recipient = false;
            }
        },
        smsSuccess(response) {
            this.$Progress.finish();
            this.isBusy = false;
            let successText = "SMS request submitted.";
            if (
                response &&
                response.data &&
                typeof response.data.message === "string"
            ) {
                const m = response.data.message.trim();
                if (m) {
                    successText = m;
                }
            }
            swal.fire({
                text: successText,
                icon: "success",
                allowOutsideClick: true,
                allowEscapeKey: true,
                showCancelButton: false,
                confirmButtonText: "OK",
                buttonsStyling: false,
                customClass: {
                    confirmButton:
                        "btn btn-size akkurate-green-btn modal-btn-width text-white me-2",
                },
            }).then(() => {
                this.$emit("sms-sent");
                this.$bvModal.hide("send-mail-all");
                this.resetFields();
            });
        },
        async sendSmsAll(bvModalEvent) {
            if (bvModalEvent && typeof bvModalEvent.preventDefault === "function") {
                bvModalEvent.preventDefault();
            }
            try {
            this.clearFormErrors();
            const rawMsg = this.sms_message || "";
            const msg = rawMsg.trim();
            if (!messageHasNonWhitespace(msg)) {
                this.smsErrorSwal(
                    "warning",
                    "Enter a message (cannot be only spaces).",
                    "Message required",
                );
                return;
            }
            if (msg.length > SMS_MESSAGE_FILTERED_MAX) {
                this.smsErrorSwal(
                    "warning",
                    "Message is too long.",
                    "Message too long",
                );
                return;
            }

            if (this.isSingleCustomerMode) {
                if (msg.length > SMS_MESSAGE_SHORT_MAX) {
                    this.smsErrorSwal(
                        "warning",
                        `Single-customer SMS is limited to ${SMS_MESSAGE_SHORT_MAX} characters.`,
                        "Message too long",
                    );
                    return;
                }
                const customer_id = parseInt(this.customerId, 10);
                if (!Number.isFinite(customer_id) || customer_id < 1) {
                    this.smsErrorSwal(
                        "warning",
                        "Invalid customer.",
                        "Invalid request",
                    );
                    return;
                }
                this.$Progress.start();
                this.isBusy = true;
                await ApiService.post(`/sms/request/customer`, {
                    customer_id,
                    message: msg,
                })
                    .then((response) => this.smsSuccess(response))
                    .catch((error) => this.handleSmsCatch(error))
                    .finally(() => {
                        this.isBusy = false;
                    });
                return;
            }

            if (this.selected === "bulk") {
                if (msg.length > SMS_MESSAGE_SHORT_MAX) {
                    this.smsErrorSwal(
                        "warning",
                        `All-customers SMS is limited to ${SMS_MESSAGE_SHORT_MAX} characters.`,
                        "Message too long",
                    );
                    return;
                }
                this.$Progress.start();
                this.isBusy = true;
                await ApiService.post(`/sms/request/all-customers`, {
                    message: msg,
                })
                    .then((response) => this.smsSuccess(response))
                    .catch((error) => this.handleSmsCatch(error))
                    .finally(() => {
                        this.isBusy = false;
                    });
                return;
            }

            if (this.selected === "custom") {
                if (msg.length > SMS_MESSAGE_SHORT_MAX) {
                    this.smsErrorSwal(
                        "warning",
                        `SMS is limited to ${SMS_MESSAGE_SHORT_MAX} characters for this mode.`,
                        "Message too long",
                    );
                    return;
                }
                const rec = normalizeCommaRecipientsString(this.recipient);
                if (!rec) {
                    this.smsErrorSwal(
                        "warning",
                        "Enter at least one phone number (one number or comma-separated).",
                        "Recipients required",
                    );
                    return;
                }
                const segments = splitRecipientSegments(rec);
                if (segments.length > SMS_MAX_COMMA_RECIPIENTS) {
                    this.smsErrorSwal(
                        "warning",
                        `Too many numbers (max ${SMS_MAX_COMMA_RECIPIENTS.toLocaleString()}). Split into smaller batches.`,
                        "Too many recipients",
                    );
                    return;
                }
                for (let i = 0; i < segments.length; i++) {
					if (!isValidSmsPhoneSegment(segments[i])) {
						this.smsErrorSwal(
							"warning",
							`Invalid phone at position ${i + 1}: use ${SMS_PHONE_SEGMENT_MIN}–${SMS_PHONE_SEGMENT_MAX} characters (digits, +, spaces, hyphens only).`,
							"Invalid phone",
						);
						return;
					}
                }
                this.$Progress.start();
                this.isBusy = true;
                const payload =
                    segments.length === 1
                        ? {
                                phone: segments[0].trim(),
                                message: msg,
                          }
                        : {
                                recipients: segments.join(", "),
                                message: msg,
                          };
                const url =
                    segments.length === 1
                        ? `/sms/request/phone`
                        : `/sms/request/multiple-phones`;
                await ApiService.post(url, payload)
                    .then((response) => this.smsSuccess(response))
                    .catch((error) => this.handleSmsCatch(error))
                    .finally(() => {
                        this.isBusy = false;
                    });
                return;
            }

            if (msg.length > SMS_MESSAGE_FILTERED_MAX) {
                this.smsErrorSwal(
                    "warning",
                    `Filtered audience SMS is limited to ${SMS_MESSAGE_FILTERED_MAX} characters.`,
                    "Message too long",
                );
                return;
            }
            const selected = this.buildAudienceSelectedPayload();
            if (!selected) {
                this.smsErrorSwal(
                    "warning",
                    "Choose a branch, product, or customer type (or an allowed customer type).",
                    "Audience required",
                );
                return;
            }
            const typeNorm = String(this.selected || "")
                .trim()
                .toLowerCase();
            this.$Progress.start();
            this.isBusy = true;
            await ApiService.post(`/sms/request/send`, {
                type: typeNorm,
                message: msg,
                selected,
            })
                .then((response) => this.smsSuccess(response))
                .catch((error) => this.handleSmsCatch(error))
                .finally(() => {
                    this.isBusy = false;
                });
            } catch (e) {
                this.$Progress.fail();
                this.isBusy = false;
                this.smsErrorSwal("error", apiErrorMessage(e, "Request failed."));
            }
        },

        // async getAccountDropdown() {
        //     this.$Progress.start();
        //     this.isBusy = true;
        //     await ApiService.get("/accounts/create/dropdown")
        //         .then((response) => {
        //             // console.log(response);
        //             this.form.branch_option = response?.data?.branches
        //             this.form.acc_types_option = response?.data?.account_types
        //             this.users_options = response?.data?.users
        //             this.isBusy = false;
        //             this.$Progress.finish();
        //         }).catch((error) => {
        //             // console.log(error);
        //         })
        // },
        // load items is what brings back the rows from server
        // async loadItems() {
        //     this.isBusy = true;
        //     this.$Progress.start();  // Start the progress bar
        //     // console.log(this.form.users);
        //     await ApiService.post("/sms/approvals/pending",
        //         {
        //             "page": this.currentPage,
        //             "per_page": this.perPage,
        //         }
        //     ).then(response => {
        //         // Handle response and update table data
        //         this.isBusy = false;  // Set isBusy to false when the data is loaded
        //         // this.$Progress.finish();  // Finish the progress bar
        //         this.rows = response.data?.approvals;
        //         // this.totalRecords = response.data.meta.total;

        //     }).catch(() => {
        //         this.isBusy = false;  // Set isBusy to false in case of an error
        //         this.$Progress.finish();  // Finish the progress bar even if there's an error
        //         return [];  // Return an empty array in case of error to prevent the table from breaking
        //     }).finally(() => {
        //         this.isBusy = false;  // Set isBusy to false in case of an error
        //         this.$Progress.finish();  // Finish the progress bar even if there's an error
        //     });
        // },
        async getInsistution() {
            await ApiService.get("/settings/institution")
                .then((response) => {
                    // console.log(response);
                    this.institution = response.data.data;
                })
                .catch((error) => {
                    // console.log(error);
                });
        },
    },

};
</script>